import React from "react"

export const plus = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.99967 3.33334V12.6667M3.33301 8H12.6663"
      stroke="black"
      stroke-width="0.5"
    />
  </svg>
)

export const wishlist = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.0858 16.3996L6 21V3H19V21L12.9142 16.3996L12.5 16.0865L12.0858 16.3996Z"
      stroke="black"
      stroke-width="0.5"
    />
  </svg>
)

export const wishlistFilled = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.0858 16.3996L6 21V3H19V21L12.9142 16.3996L12.5 16.0865L12.0858 16.3996Z"
      fill="black"
      stroke="black"
      stroke-width="0.5"
    />
  </svg>
)

export const chevronRight = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9 6L15 12L9 18"
      stroke="black"
      stroke-width="0.5"
      stroke-linecap="square"
    />
  </svg>
)

export const chevronLeft = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15 6L9 12L15 18"
      stroke="black"
      stroke-width="0.5"
      stroke-linecap="square"
    />
  </svg>
)

export const chevronDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="black"
      stroke-width="0.5"
      stroke-linecap="square"
    />
  </svg>
)

export const chevronUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15 12.5L10 7.5L5 12.5"
      stroke="black"
      stroke-width="0.5"
      stroke-linecap="square"
    />
  </svg>
)

export const close = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M9.5 9.5L5.96447 6M5.96447 6L2.5 2.57035M5.96447 6L9.5 2.5M5.96447 6L2.5 9.42965"
      stroke="black"
      stroke-width="0.5"
    />
  </svg>
)

export const search = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.90358 9.9752L14.4285 14.4999M11.5704 6.5C11.5704 9.26142 9.33183 11.5 6.57037 11.5C3.80892 11.5 1.57031 9.26142 1.57031 6.5C1.57031 3.73858 3.80892 1.5 6.57037 1.5C9.33183 1.5 11.5704 3.73858 11.5704 6.5Z"
      stroke="black"
      stroke-width="0.5"
    />
  </svg>
)
